var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!!_vm.item)?_c('ViewItemTypeGroup',{on:{"success":_vm.alertSuccess}}):_vm._e(),_c('ItemTypeGroupTable',{ref:"table",attrs:{"title":"Users"},on:{"addHealth":_vm.showModal}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }